module.exports = __webpack_public_path__ + "assets/img/pytwo.6898082d.png";